import {Component, Input, OnInit} from '@angular/core';

@Component({
  selector: 'app-add-cmp',
  templateUrl: './add-cmp.component.html',
  styleUrls: ['./add-cmp.component.scss']
})
export class AddCmpComponent implements OnInit {

  @Input() data: any;
  columns: string [] = [];
  constructor() { }

  async ngOnInit() {
    this.getItems();
  }
  saveApi() {
  }
  deletearrayColumn(a, column) {
    if (this.data[column].length > 1) {
      this.data[column].splice(a, 1);
    }
  }
  getItems() {
    // for (const item of this.data) {
    //   this.columns = [];
    for (const itemval in this.data) {
      this.columns.push(itemval);
      // if (this.typeof(this.data.itemval) === 'don\'t know' || this.typeof(this.data.itemval) === 'undefined') {
      //   this.data[itemval] = null;
      // } else if (this.typeof(this.data.itemval) === 'String') {
      //   this.data[itemval] = '';
      // }
      }
    }
  addColumn(data) {
    let temp: any;
    temp = JSON.parse(JSON.stringify(data[0]));
    data.push(temp);
  }
  typeof(object) {
    let stringConstructor = 'test'.constructor;
    let arrayConstructor = [].constructor;
    let objectConstructor = ({}).constructor;

    if (object === null) {
      return 'null';
    }
    if (object === undefined) {
      return 'undefined';
    }
    if (object.constructor === stringConstructor) {
      return 'String';
    }
    if (object.constructor === arrayConstructor) {
      return 'array';
    }
    if (object.constructor === objectConstructor) {
      return 'object';
    }
    {
      return 'don\'t know';
    }
  }
  stringifyjson(val) {
    return JSON.stringify(val);
  }
}
